import { useCommon } from "../../Hooks/Common/useCommon";
import { useVpnRequestList } from "../../Hooks/Features/HelpDesk/useVpnRequestList";
import { AgGridReact } from "@ag-grid-community/react";
import DatePicker from "react-multi-date-picker";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { SkeletonDataTable } from "../Loader/Loader";
import { Dropdown } from "primereact/dropdown";
import RequestPopup from "./RequestPopup";
import { expriryData, handleDurationSelect } from "../../utils/Helper";
import { useTheme } from "../../context/ThemeContext";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
const VpnRequestList = () => {
    const { theme } = useTheme();
    const { loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, approval, setApproval, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, handleRequest, editData, setEditData, showInfo, onGridReady } = useVpnRequestList({ fromReport: false });
    const { checkPermission } = useCommon();

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "vpn_tab"}' >
                <div className="row sk-header-row">
                    <div className="col-md-5 col-12">
                        <div className="row">
                            <div className="col-md-8 col-12">
                             <CommonFilterDropdown
                                fields={[
                                    { key: "projects", label: "Projects", col: 6 },
                                    { key: "all_users", label: "Users", col: 6 },                    
                                ]}
                                filterValues={filterValues}
                                setFilterValues={setFilterValues} />
                           </div>
                            <div className="col-md-4 col-12 px-1">
                                <Dropdown
                                    className="sk-input-dd"
                                    options={dropDownOption?.vpnType}
                                    optionLabel="vpn_type_name"
                                    value={filterValues.vpnType}
                                    onChange={(e) => {
                                        setFilterValues((prev) => ({ ...prev, vpnType: e.value, isChange: true }))
                                        e.value === undefined && getRequestedData("clear")
                                    }} placeholder="Vpn Type"
                                    filter
                                    filterInputAutoFocus
                                    showClear
                                    onHide={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 col-12">
                        <DatePicker
                            value={filterValues?.hoveredRange}
                            onChange={(e) => { setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true })); }}
                            range
                            rangeHover
                            placeholder="Select Date"
                            onClose={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                        />
                    </div>
                    <div className="d-flex flex-wrap align-items-center col-md-3 col-12">
                        {dropDownOption?.statusOptions?.map((item) => (
                            <div
                                key={item.request_status_id}
                                className="d-flex justify-content-center align-items-center"
                            >
                                <input
                                    type="radio"
                                    id={item.request_status_id}
                                    name="status"
                                    value={item.request_status_id}
                                    onChange={(e) => handleStatusChange(e)}
                                    checked={
                                        filterValues.status?.request_status_id ===
                                        item.request_status_id
                                    }
                                    className="sk-radio"
                                />
                                <label htmlFor={item.request_status_id} className="sk-radio-label">
                                    {item.request_status_name}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-2 d-flex gap-2 justify-content-end col-12">
                        <button className="sk-btn sk-btn-primary" onClick={() => getRequestedData()}><i className="icon-refresh-outline" /> </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)}><i className="icon-add-outline" /> </button>
                    </div>
                </div>
                <div ref={() => checkPermission("help desk", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "helpdesk", "data": "helpdesk_action_col"}' >
                        <div className="d-flex justify-content-end gap-2 ">
                            <button className="sk-btn sk-btn-primary " onClick={() => {
                                const data = rowData?.filter(item => item.is_checked === true)?.map(item => item.vpn_request_id)
                                if (data?.length <= 0 || !data) {
                                    showInfo("Info", "Please select a request to approve");
                                    return
                                }
                                setShowApprovePopup(true);
                                setApproval((prevState) => ({ ...prevState, data, status: "is_approved", selectedRadio: "" }))
                            }}>Approve All</button>

                            <button className="sk-btn sk-btn-danger " onClick={() => handleRequest("is_rejected", rowData?.filter(item => item.is_checked === true)?.map(item => item.vpn_request_id), "reject")}>Reject All</button>
                        </div>
                    </div>
                </div>
                {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                    <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 110px)" }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={30}
                            onGridReady={onGridReady}
                        />
                    </div>
                }
                <Dialog visible={showApprovePopup} header="Approve Request" onHide={() => {
                    setShowApprovePopup(false);
                }} className="modal-small" draggable={false}>
                    <div>
                        <div className="dialog-content">
                            <div className="d-flex gap-4  mt-2">
                                <div className='w-50 inspectra-calendar'>
                                    <label>From Date</label>
                                    <Calendar
                                        className="input-dd"
                                        dateFormat='dd-mm-yy'
                                        style={{ height: "100%" }}
                                        placeholder="From Date"
                                        name='from_date'
                                        value={approval?.from_date}
                                        onChange={(e) => setApproval((prev) => ({ ...prev, from_date: e.target.value, to_date: null, selectedRadio: "" }))}
                                        minDate={new Date()}
                                    />
                                </div>

                                <div className='w-50 inspectra-calendar'>
                                    <label>To Date</label>
                                    <Calendar
                                        className="input-dd"
                                        dateFormat='dd-mm-yy'
                                        style={{ height: "100%" }}
                                        placeholder="To Date"
                                        name='to_date'
                                        value={approval?.to_date}
                                        onChange={(e) => setApproval((prev) => ({ ...prev, to_date: e.target.value, selectedRadio: "" }))}
                                        minDate={approval.from_date ? new Date(approval.from_date) : new Date()}
                                        maxDate={
                                            approval?.from_date
                                                ? new Date(new Date(approval.from_date).setMonth(new Date(approval.from_date).getMonth() + 1))
                                                : null
                                        }
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center text-center my-2" >
                                <hr style={{ flex: 1, }} className="border-top border-secondary" />
                                <span style={{ padding: '0 10px', color: '#666' }}>OR</span>
                                <hr style={{ flex: 1, }} className="border-top border-secondary" />
                            </div>
                            <div>
                                <div className="">
                                    Expiry Duration
                                </div>
                                {expriryData.slice(0, 3)?.map((d) => (
                                    <div className="form-check-inline" key={d.value}>
                                        <input
                                            type="radio"
                                            id={d.value}
                                            name="duration"
                                            value={d.value}
                                            checked={d.value === approval?.selectedRadio}
                                            onChange={(e) => setApproval((prev) => ({ ...prev, from_date: new Date(), to_date: handleDurationSelect(d.value), selectedRadio: d.value }))}
                                        />
                                        <label htmlFor={d.value} className="sk-radio-label">
                                            {d.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2 justify-content-center my-4" >
                        <button className="sk-btn sk-btn-primary"
                            onClick={() => handleRequest(null, null, "approve")}
                        > Confirm </button>
                        <button
                            onClick={() => {
                                setShowApprovePopup(false)
                            }}
                            className="sk-btn sk-btn-primary">
                            Cancel
                        </button>
                    </div>
                </Dialog>
                {
                    showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="vpn_tab" />
                }
            </div>
        </div>
    )
}

export default VpnRequestList